import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-3xl p-8 sm:p-12 shadow-2xl relative overflow-hidden" data-id="element-148">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-149" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-150" />

          <div className="relative z-10" data-id="element-151">
            <div className="flex items-center gap-4 mb-8" data-id="element-152">
              <div className="p-3 bg-gold-500/20 rounded-xl" data-id="element-153">
                <Clock className="w-8 h-8 text-gold-500" data-id="element-154" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-cream-50" data-id="element-155">
                Lo que cambia en 7 días
              </h2>
            </div>

            <div className="space-y-6" data-id="element-156">
              <p className="text-xl sm:text-2xl text-cream-100 font-serif leading-relaxed" data-id="element-157">
                Pasarás de pasar 4 horas al día escribiendo a extraños, a
                dedicar solo{' '}
                <span className="text-gold-500 font-bold" data-id="element-158">45 minutos</span> a
                conversaciones con personas que ya tienen la tarjeta de crédito
                en la mano.
              </p>
              <p className="text-lg text-cream-100/80 leading-relaxed" data-id="element-159">
                Tu WhatsApp dejará de ser una fuente de estrés para convertirse
                en tu herramienta de libertad financiera.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}